import { Skeleton, Stack, styled } from "@mui/material";
import React from "react";

const SkeletonChatItemLarge = styled(Skeleton)(
    ({ theme }) => `
        width: 300px;
        height: 75px;
        border-radius: var(--border-radius);
    `
)

const SkeletonChatItemSmall = styled(Skeleton)(
    ({ theme }) => `
        width: 175px;
        height: 45px;
        border-radius: var(--border-radius);
    `
)

const SkeletonChatList = styled(Skeleton)(
    ({ theme }) => `
        width: 100%;
        height: 100px;
        border-radius: var(--border-radius);
    `
)

const ChatBottomStyle = styled(Stack)(
    ({ theme }) => `
        width: 100%;
        position: fixed;
        bottom: 0;
        left: 0;
        padding: 16px 19px;
        background: #16423C;
        border-radius: 8px 8px 0 0;
        z-index: 999;
    `
)

export function ChatDetailLoader() {

    return (
        <Stack spacing={2} sx={{p: 2}}>
            <Stack alignItems="flex-start" spacing={2} sx={{width: "100%"}}>
                <SkeletonChatItemLarge variant="rounded" />
                <SkeletonChatItemSmall variant="rounded" />
            </Stack>
            <Stack alignItems="flex-end" spacing={2} sx={{width: "100%"}}>
                <SkeletonChatItemLarge variant="rounded" />
                <SkeletonChatItemSmall variant="rounded" />
            </Stack>
            <Stack alignItems="flex-start" spacing={2} sx={{width: "100%"}}>
                <SkeletonChatItemLarge height={45} variant="rounded" />
            </Stack>
        </Stack>
    )
}

export function ChatSubmitLoader() {

    return (
        <ChatBottomStyle spacing={2} sx={{p: 2}}>
            <Stack alignItems="flex-start" justifyContent="space-between" direction="row" spacing={2} sx={{width: "100%"}}>
                <Skeleton sx={{background: "#656565"}} variant="rounded" height="36px" width="40px" />
                <Skeleton sx={{background: "#656565"}} variant="rounded" height="36px" width="40px" />
                <Skeleton sx={{background: "#656565"}} variant="rounded" height="36px" width="calc(100% - 40px)" />
            </Stack>
        </ChatBottomStyle>
    )
}

export function ChatListLoader() {

    return (
        <Stack alignItems="flex-start" spacing={2} sx={{width: "100%"}}>
            <SkeletonChatList variant="rounded" />
            <SkeletonChatList variant="rounded" />
            <SkeletonChatList variant="rounded" />
            <SkeletonChatList variant="rounded" />
            <SkeletonChatList variant="rounded" />
        </Stack>
    )
}
